<template>
  <div class="mobile-forever-root">

    <router-view />
    <!-- <sidebarMain />  -->
    <interMain ref="interDom" />
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';
// import sidebarMain from '@/components/sidebar/index.vue'
import interMain from '@/components/inter/index.vue';
import { useRoute } from 'vue-router';
const route = useRoute()

import { useUserStore } from '@/stores/index';
const userStore = useUserStore()


const backAudio = new Audio('https://c-4file.oss-cn-hongkong.aliyuncs.com/audio/back.mp3'); // 创建音频实例


backAudio.onended = () => {
  console.log('音频播放完成，重新播放')
  // 重置播放位置并重新播放
  backAudio.currentTime = 0
  backAudio.play()
}

// 监听路由变化
watch(
  () => route.path, // 监听 path 变化
  (newPath, oldPath) => {
    if (newPath != ' /login') {
      backAudio.play().catch(err => { })
    }
  }
);




import { getLocalIP } from '@/utils/getIp'

getLocalIP().then((ip) => {
  let aIp = ip || '0.0.0.0'
  sessionStorage.setItem('ip', aIp)
});


//判断访问设备
const isMobile = () => {
  let device = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  if (!device) {
    document.body.className = `bodyBigBg`
  } else {
    document.body.className = `mobileBigBg`
  }
}
isMobile()


const interDom = ref(null)
const startJson = () => {
  interDom.value.setInterFun(true)
  setTimeout(() => {
    interDom.value.setInterFun(false)
    userStore.setChangePageShow(false)
  }, 1500);
}

watch(() => userStore.changePageShow, value => {
  if (value) {
    startJson()
  }
}, {
  deep: true
})






const getZoomLevel = () => {
  // 屏幕宽度和窗口宽度的比例
  return window.innerWidth / screen.width;
}
getZoomLevel()

console.log("当前缩放级别: " + getZoomLevel().toFixed(2) + "x");
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
  color: #fff;
  outline: none;
   //touch-action: none; // 阻止所有触摸事件的默认行为
  image-rendering: -moz-crisp-edges;
  /* Firefox */
  image-rendering: -o-crisp-edges;
  /* Opera */
  image-rendering: -webkit-optimize-contrast;
  /* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
  /* IE (non-standard property) */
  box-sizing: border-box;
  font-family: 'zfont';
}

.bodyBigBg {
  height: 100vh;
  background: url("./assets/img/base/back.png") no-repeat fixed center;
  background-size: cover;
}

.mobileBigBg {
  height: 100vh;
  background: url('./assets/img/base/appBack.png') no-repeat center;
  background-size: 100% 100%;
}

.hide {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.changePageBox {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  opacity: 0;
  z-index: -1;
  overflow: hidden;

  .lottieBox {
    width: 120%;
    height: 120%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &.active {
    opacity: 1;
    z-index: 99999;
  }
}

/* 如果需要自定义PC端样式 */
@media (min-width: 768px) {

  #app {
    /* 自定义主内容区域样式 */
    // box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    // border-radius: 20px;
    overflow: hidden;
    position: relative;
  }
}
</style>
